var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkcompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.184 0 0 7.184 0 16C0 24.816 7.184 32 16 32C24.816 32 32 24.816 32 16C32 7.184 24.816 0 16 0ZM23.648 12.32L14.576 21.392C14.352 21.616 14.048 21.744 13.728 21.744C13.408 21.744 13.104 21.616 12.88 21.392L8.352 16.864C7.888 16.4 7.888 15.632 8.352 15.168C8.816 14.704 9.584 14.704 10.048 15.168L13.728 18.848L21.952 10.624C22.416 10.16 23.184 10.16 23.648 10.624C24.112 11.088 24.112 11.84 23.648 12.32Z",
    fill: "#02B17B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkcompleted);
export default __webpack_public_path__ + "static/media/darkcompleted.9df2c5c7db2248cd0c133473a7e3b81d.svg";
export { ForwardRef as ReactComponent };